import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    EXPORT_LIST: {
        url: "beheer/export/list",
        method: "post",
    },

    SAVE_EXPORT: {
        url: "/beheer/export/save",
        method: "post",
    },

    SAVE_EXPORT_HISTORY: {
        url: "/beheer/export/save-history",
        method: "post",
    },

    EXPORT_HISTORY: {
        url: "beheer/export/history",
        method: "get",
    },

    ORGANIZATIONS: {
        url: "organizations-list",
        method: "get",
    },

    // SCHOOLS: {
    //     url: (communityId) => `schools?iCommunityId=${communityId}`,
    //     method: "get",
    // },

     SCHOOLS: {
        url:'schools',
        method: "get",
    },

    EMPLOYEE_LIST: {
        url: "/beheer/export/employee-list",
        method: "post",
    }
};

export const useExportList = () =>
    useApiFetcherSWR(API_ENDPOINT.EXPORT_LIST);

export const useOrganizations = () =>
    useApiFetcherSWR(API_ENDPOINT.ORGANIZATIONS);

export const useSaveExport = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_EXPORT);

export const useSaveExportHistory = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_EXPORT_HISTORY);

export const useExportHistory = (iCommunityId) => {
    const shouldFetch = Boolean(iCommunityId);

    return useApiFetcherSWR(
        shouldFetch
            ? {
                url: `beheer/export/history?iCommunityId=${iCommunityId}`,
                method: "get",
            }
            : null
    );
};

// export const useSchools = ({ communityId, shouldFetch = true }) =>
//     useApiFetcherSWR(
//         shouldFetch && communityId
//             ? {
//                 ...API_ENDPOINT.SCHOOLS,
//                 url: API_ENDPOINT.SCHOOLS.url(communityId),
//             }
//             : null
//     );

export const useSchools = () =>
    useApiFetcherSWR(API_ENDPOINT.SCHOOLS);

export const useEmployeeList = () =>
    useApiFetcherSWR(API_ENDPOINT.EMPLOYEE_LIST);